module.exports = __webpack_public_path__ + "static/img/hsy_logo_w.21980fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hsy_logo_w.png
// module id = 00Qx
// module chunks = 47